import { Button, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import PDialog from "../../components/pos/PDialog";
import React from "react";
import { TimelineOppositeContent } from "@mui/lab";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "6px 16px",
  },
  secondaryTail: {
    backgroundColor: theme.palette.success.main,
  },
  progressColor: {
    backgroundColor: theme.palette.warning.main,
  },
  completedColor: {
    backgroundColor: theme.palette.success.main,
  },
  grey: {
    backgroundColor: theme.palette.grey.main,
  },
}));

export default function ImportProgress(props) {
  const classes = useStyles();
  const content = (
    <Grid container>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        <Typography variant="h6" gutterBottom>
          Import Status
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Timeline align="alternate">
          <TimelineItem>
            <TimelineOppositeContent>
              <Typography>Vendors</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                className={
                  props.vendorProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.vendorProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
              <TimelineConnector
                className={
                  props.vendorProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.vendorProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
            </TimelineSeparator>
            <TimelineContent>
              <Typography>{props.vendorProgressMessage}</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent>
              <Typography>{props.categoryProgressMessage}</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                className={
                  props.categoryProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.categoryProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
              <TimelineConnector
                className={
                  props.categoryProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.categoryProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
            </TimelineSeparator>
            <TimelineContent>
              <Typography>Categories</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent>
              <Typography>Product-Analysing</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                className={
                  props.prodAnalysingStats === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.prodAnalysingStats === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
              <TimelineConnector
                className={
                  props.prodAnalysingStats === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.prodAnalysingStats === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
            </TimelineSeparator>
            <TimelineContent>
              <Typography>{props.prodAnalysingMessage}</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent>
              <Typography>{props.productyProgressMessage}</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                className={
                  props.productProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.productProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
              <TimelineConnector
                className={
                  props.productProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.productProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
            </TimelineSeparator>
            <TimelineContent>
              <Typography>Product</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent>
              <Typography>Done</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                className={
                  props.productProgress === "IN_PROGRESS"
                    ? classes.progressColor
                    : props.productProgress === "COMPLETED"
                    ? classes.completedColor
                    : classes.grey
                }
              />
            </TimelineSeparator>
            <TimelineContent>
              <Typography></Typography>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </Grid>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        {props.productProgress === "COMPLETED" && (
          <Button
            variant="contained"
            color="primary"
            onClick={props.handleClose}
          >
            CLOSE
          </Button>
        )}
      </Grid>
    </Grid>
  );
  return (
    <div>
      <PDialog
        content={content}
        maxWidth={"md"}
        fullWidth={true}
        open={true}
        mode={"create"}
        hideSave={true}
        borderLess={true}
      ></PDialog>
    </div>
  );
}
